import React from "react";
import { HOST_PREFIX } from "../../Network/ApiPaths";

function formatDateTimeToDisplay(dateTimeStr) {
  if (!dateTimeStr) return "";
  const [date] = dateTimeStr.split(" "); // take only yyyy-mm-dd
  const [year, month, day] = date.split("-");
  return `${day}-${month}-${year}`;
}

class VendorPaymentComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: "",
      vendor_id: "",
      invoice_id: "",
      invoice_amount: "",
      pending_amount: "",
      payment_date: "",
      payment_amount: "",
      balance_after: "",
      payment_mode: "",
      transaction_ref: "",
      payment_file: "",
      notes: "",
    };
  }

  updatePaymentState = (payment) => {
    const invoice = this.props.invoices.find(
      inv => Number(inv.id) === Number(payment.invoice_id)
    );
    const totalPaid = this.props.payments
      .filter(
        (p) =>
          Number(p.invoice_id) === Number(payment.invoice_id) &&
          Number(p.id) !== Number(payment.id)
      )
      .reduce((sum, p) => sum + Number(p.payment_amount), 0);

    const pendingAmount = invoice
      ? Number(invoice.invoice_amount) - totalPaid
      : 0;
    this.setState({
      id: payment.id,
      vendor_id: payment.vendor_id,
      invoice_id: payment.invoice_id,
      invoice_amount: invoice ? invoice.invoice_amount : "",
      pending_amount: pendingAmount,
      payment_amount: payment.payment_amount,
      payment_date: payment.payment_date,
      balance_after: Math.max(0, pendingAmount - Number(payment.payment_amount)),
      payment_mode: payment.payment_mode,
      transaction_ref: payment.transaction_ref,
      payment_file: payment.payment_file,
      notes: payment.notes
    });
  };

  render() {
    // Apply filters on invoices (so NOTPAID invoices are always visible)
    let filteredInvoices = this.props.invoices || [];
    // Vendor filter
    if (this.props.filterVendorId) {
      filteredInvoices = filteredInvoices.filter(
        (inv) => Number(inv.vendor_id) === Number(this.props.filterVendorId)
      );
    }
    // Status filter
    if (this.props.filterStatus) {
      filteredInvoices = filteredInvoices.filter(
        (inv) => inv.status === this.props.filterStatus
      );
    }
    // Payment date filter
    if (this.props.filterFromDate || this.props.filterToDate) {
      filteredInvoices = filteredInvoices.filter((inv) => {
        const invPayments = this.props.payments.filter(
          (p) => Number(p.invoice_id) === Number(inv.id)
        );
        return invPayments.some((p) => {
          const paymentDate = p.payment_date.split(" ")[0];
          return (
            (!this.props.filterFromDate ||
              paymentDate >= this.props.filterFromDate) &&
            (!this.props.filterToDate ||
              paymentDate <= this.props.filterToDate)
          );
        });
      });
    }

    const payments = this.props.payments || [];

    return (
      <div>
        {/* Add Invoice Modal */}
        <div id="paymentModal" className="modal fade" tabIndex="-1" role="dialog" aria-hidden="true">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Record Payment</h4>
                <button type="button" className="close" data-dismiss="modal">
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <form id="vendorupdateform">
                  {/* Vendor Dropdown */}
                  <div className="form-group">
                    <label>Vendor</label>
                    <select className="form-control" value={this.props.selectedVendor} onChange={this.props.onVendorChange}>
                      <option value="">Select Vendor</option>
                      {this.props.vendors &&
                        this.props.vendors.map((v) => (
                          <option key={v.id} value={v.id}>
                            {v.vendor_name}
                          </option>
                        ))}
                    </select>
                  </div>
                  <select
                    className="form-control"
                    value={this.props.selectedInvoice}
                    onChange={this.props.onInvoiceChange}
                  >
                    <option value="">Select Invoice Date</option>
                    {this.props.invoices
                      .filter(
                        inv =>
                          Number(inv.vendor_id) === Number(this.props.selectedVendor) &&
                          (inv.status === "NOTPAID" || inv.status === "PARTIAL")
                      )
                      .map(inv => (
                        <option key={inv.id} value={inv.id}>
                          {formatDateTimeToDisplay(inv.invoice_date)} - ₹{inv.invoice_amount} - {inv.status}
                        </option>
                      ))
                    }
                  </select>

                  <div className="form-group">
                    <label>Invoice Amount</label>
                    {this.props.invoices
                      .filter(inv => Number(inv.id) === Number(this.props.selectedInvoice))
                      .map(inv => (
                        <input
                          key={inv.id}
                          type="number"
                          className="form-control"
                          value={inv.invoice_amount}
                          readOnly
                        />
                      ))
                    }
                  </div>

                  <div className="form-group">
                    <label>Pending Amount</label>
                    <input
                      type="number"
                      className="form-control"
                      value={this.props.pendingAmount}
                      readOnly
                    />
                  </div>

                  <div className="form-group">
                    <label>Payment Amount</label>
                    <input type="number" className="form-control" min="0" value={this.props.paymentAmount} onChange={this.props.onPaymentAmountChange} />
                  </div>

                  <div className="form-group">
                    <label>Balance After</label>
                    {this.props.invoices
                      .filter(
                        (inv) =>
                          Number(inv.vendor_id) === Number(this.props.selectedVendor) &&
                          Number(inv.id) === Number(this.props.selectedInvoice)
                      )
                      .map((inv) => (<input key={inv.id} type="number" className="form-control" value={Math.max(0, Number(this.props.pendingAmount) - Number(this.props.paymentAmount || 0))} readOnly />))}
                  </div>

                  <div className="form-group">
                    <label>Payment Date</label>
                    <input
                      type="date"
                      className="form-control"
                      value={this.props.paymentDate}
                      min={
                        this.props.invoices
                          .find(inv => Number(inv.id) === Number(this.props.selectedInvoice))
                          ?.invoice_date?.split(" ")[0] || ""
                      }
                      max={new Date().toISOString().split("T")[0]}
                      onChange={this.props.onPaymentDateChange}
                    />
                  </div>

                  <div className="form-group">
                    <label>Payment Mode</label>
                    <select className="form-control" value={this.props.paymentMode} onChange={this.props.onPaymentModeChange}>
                      <option value="">Select Mode</option>
                      <option value="Cash">Cash</option>
                      <option value="Bank Transfer">Bank Transfer</option>
                      <option value="UPI">UPI</option>
                      <option value="Cheque">Cheque</option>
                      <option value="Credit Card">Credit Card</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <label>Transaction Reference No.</label>
                    <input type="text" className="form-control" value={this.props.transactionRef} onChange={this.props.onTransactionRefChange} />
                  </div>

                  <div className="form-group">
                    <label>Upload Proof</label>
                    <input type="file" className="form-control" accept="image/*,.pdf" onChange={this.props.onPaymentFileChange} />
                  </div>

                  <div className="form-group">
                    <label>Notes</label>
                    <textarea className="form-control" value={this.props.notes} onChange={this.props.onNotesChange} />
                  </div>

                  <button type="button" className="btn btn-primary" onClick={(e) => { e.preventDefault(); this.props.addPayment(e); }} data-dismiss="modal">
                    Save Payment
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* 🔹 Edit Invoice Modal */}
        <div id="paymentEditModal" className="modal fade" tabIndex="-1" role="dialog" aria-hidden="true">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Edit Payment</h4>
                <button type="button" className="close" data-dismiss="modal">
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <form>
                  <div className="form-group">
                    <label>Vendor</label>
                    <select className="form-control" value={this.state.vendor_id} disabled>
                      {this.props.vendors.map((v) => (
                        <option key={v.id} value={v.id}>{v.vendor_name}</option>
                      ))}
                    </select>
                  </div>

                  <div className="form-group">
                    <label>Invoice Amount</label>
                    <input
                      type="number"
                      className="form-control"
                      value={this.state.invoice_amount}
                      readOnly
                    />
                  </div>

                  <div className="form-group">
                    <label>Pending Amount</label>
                    <input
                      type="number"
                      className="form-control"
                      value={this.state.pending_amount}
                      readOnly
                    />
                  </div>

                  <div className="form-group">
                    <label>Payment Amount</label>
                    <input
                      type="number"
                      className="form-control"
                      min="0"
                      max={this.state.pending_amount}
                      value={this.state.payment_amount}
                      onChange={(e) => {
                        const payment = Number(e.target.value);
                        if (payment > Number(this.state.pending_amount)) {
                          alert("Payment Amount cannot be greater than Pending Amount");
                          return;
                        }
                        this.setState({
                          payment_amount: payment,
                          balance_after: Math.max(0, Number(this.state.pending_amount) - payment).toFixed(2),
                        });
                      }}
                    />
                  </div>

                  <div className="form-group">
                    <label>Balance After</label>
                    <input
                      type="number"
                      className="form-control"
                      value={this.state.balance_after}
                      readOnly
                    />
                  </div>

                  <div className="form-group">
                    <label>Payment Date</label>
                    <input
                      type="date"
                      className="form-control"
                      value={this.state.payment_date
                        ? this.state.payment_date.split(" ")[0]
                        : ""}
                      onChange={(e) =>
                        this.setState({
                          payment_date: e.target.value,
                        })}
                    />
                  </div>

                  <div className="form-group">
                    <label>Payment Mode</label>
                    <select className="form-control" value={this.state.payment_mode} onChange={(e) => this.setState({ payment_mode: e.target.value })}>
                      <option value="Cash">Cash</option>
                      <option value="Bank Transfer">Bank Transfer</option>
                      <option value="UPI">UPI</option>
                      <option value="Cheque">Cheque</option>
                      <option value="Credit Card">Credit Card</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <label>Transaction Reference No.</label>
                    <input type="text" className="form-control" value={this.state.transaction_ref} onChange={(e) => this.setState({ transaction_ref: e.target.value })} />
                  </div>

                  <div className="form-group">
                    <label>Notes</label>
                    <textarea className="form-control" value={this.state.notes} onChange={(e) => this.setState({ notes: e.target.value })} />
                  </div>
                  {/* 🔹 File Upload */}
                  <div className="form-group">
                    <label>Upload Payment Photo</label>
                    <input
                      type="file"
                      className="form-control"
                      accept="image/*,.pdf"
                      onChange={(e) => {
                        this.setState({
                          payment_file: e.target.files[0]
                        });
                      }}
                    />
                    {typeof this.state.payment_file === "string" &&
                      this.state.payment_file !== "" && (
                        <a
                          href={`${HOST_PREFIX}images/payments/${this.state.id}/${this.state.payment_file}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {this.state.payment_file}
                        </a>
                      )}
                  </div>
                  <button type="button" className="btn btn-primary" onClick={(e) => { e.preventDefault(); this.props.updatePayment(this.state); }} data-dismiss="modal">
                    Update
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>

        <div className="card-body border-bottom">
          <div
            className="d-flex align-items-center"
            style={{ gap: "10px" }}
          >
            <input
              type="file"
              className="form-control"
              accept=".xlsx,.xls"
              onChange={this.props.onImportFileChange}
              disabled={this.props.importing}
            />
            <button
              className="btn btn-primary"
              onClick={this.props.importExcel}
              disabled={this.props.importing}
            >
              {this.props.importing ? "Importing..." : "Import Excel"}
            </button>
          </div>
        </div>
        {this.props.importing && (
          <div className="mt-3">
            <div className="progress">
              <div
                className="progress-bar progress-bar-striped progress-bar-animated"
                role="progressbar"
                style={{ width: `${this.props.importProgress}%` }}
              >
                {this.props.importProgress}%
              </div>
            </div>
            <small className="text-primary">
              Importing... {this.props.importProgress}%
            </small>
          </div>
        )}
        {/* Payments Table */}
        <div className="card">
          <div className="card-header d-flex justify-content-between align-items-center flex-wrap">
            <h3 className="h4">Payments</h3>
            <div className="d-flex flex-wrap" style={{ gap: "10px" }}>
              <select className="form-control" value={this.props.filterVendorId} onChange={this.props.onFilterVendorChange}>
                <option value="">All Vendors</option>
                {this.props.vendors.map((v) => (
                  <option key={v.id} value={v.id}>{v.vendor_name}</option>
                ))}
              </select>
              <select className="form-control" value={this.props.filterStatus} onChange={this.props.onFilterStatusChange}>
                <option value="">All Status</option>
                <option value="NOTPAID">Not Paid</option>
                <option value="PARTIAL">Partial</option>
                <option value="PAID">Paid</option>
              </select>
              <input type="date" className="form-control" value={this.props.filterFromDate} onChange={this.props.onFilterFromDateChange} />
              <input type="date" className="form-control" value={this.props.filterToDate} onChange={this.props.onFilterToDateChange} />
              <button className="btn btn-secondary" onClick={this.props.onResetFilters}>Reset Filters</button>
              <button
                className="btn btn-success"
                onClick={() => {
                  const filteredPayments = payments.filter((p) =>
                    filteredInvoices.some(
                      (inv) => Number(inv.id) === Number(p.invoice_id)
                    )
                  );
                  this.props.onExport(filteredPayments);
                }}
              >
                Export to Excel
              </button>
              <button className="btn btn-primary" data-toggle="modal" data-target="#paymentModal" onClick={this.props.refreshInvoices}>Add Payment</button>
            </div>
          </div>

          <div className="card-body">
            <div className="table-responsive">
              <table className="table text-center">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Vendor</th>
                    <th>Invoice Date</th>
                    <th>Invoice Amount</th>
                    <th>Status</th>
                    <th>Payment Date</th>
                    <th>Amount Paid</th>
                    <th>Balance After</th>
                    <th>Mode</th>
                    <th>Ref No.</th>
                    <th>Notes</th>
                    <th>Attachment</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredInvoices.length > 0 ? (
                    filteredInvoices.map((inv, i) => {
                      // Get all payments linked to this invoice
                      const invPayments = payments.filter(
                        p => Number(p.invoice_id) === Number(inv.id)
                      );
                      const vendorName = this.props.vendors.find(
                        v => Number(v.id) === Number(inv.vendor_id)
                      )?.vendor_name || "-";

                      if (invPayments.length === 0) {
                        // Show invoice row with no payment details (NOTPAID)
                        return (
                          <tr key={`inv-${inv.id}`}>
                            <td>{i + 1}</td>
                            <td>{vendorName}</td>
                            <td>{formatDateTimeToDisplay(inv.invoice_date)}</td>
                            <td>{inv.invoice_amount}</td>
                            <td>
                              <span className={`badge ${inv.status === "PAID" ? "badge-success" :
                                inv.status === "PARTIAL" ? "badge-warning" :
                                  inv.status === "OVERPAID" ? "badge-info" :
                                    "badge-danger"
                                }`}>
                                {inv.status}
                              </span>
                            </td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td></td>
                          </tr>
                        );
                      }

                      // Sort payments by date then by id for consistent ordering
                      const sortedInvPayments = [...invPayments].sort((a, b) => {
                        const dateDiff = new Date(a.payment_date) - new Date(b.payment_date);
                        return dateDiff !== 0 ? dateDiff : Number(a.id) - Number(b.id);
                      });

                      // Compute running balance for each payment dynamically
                      let runningBalance = Number(inv.invoice_amount);
                      const balanceAfterMap = {};
                      sortedInvPayments.forEach((sp) => {
                        runningBalance -= Number(sp.payment_amount);
                        balanceAfterMap[sp.id] = runningBalance;
                      });

                      // Show one row per payment under this invoice
                      return sortedInvPayments.map((p, pi) => (
                        <tr key={`pay-${p.id}`}>
                          <td>{pi === 0 ? i + 1 : ""}</td>
                          <td>{pi === 0 ? vendorName : ""}</td>
                          <td>{pi === 0 ? formatDateTimeToDisplay(inv.invoice_date) : ""}</td>
                          <td>{pi === 0 ? inv.invoice_amount : ""}</td>
                          <td>
                            {pi === 0 ? (
                              <span className={`badge ${inv.status === "PAID" ? "badge-success" :
                                inv.status === "PARTIAL" ? "badge-warning" :
                                  inv.status === "OVERPAID" ? "badge-info" :
                                    "badge-danger"
                                }`}>
                                {inv.status}
                              </span>
                            ) : ""}
                          </td>
                          <td>{formatDateTimeToDisplay(p.payment_date)}</td>
                          <td>{p.payment_amount}</td>
                          <td>{balanceAfterMap[p.id] !== undefined ? balanceAfterMap[p.id] : p.balance_after}</td>
                          <td>{p.payment_mode}</td>
                          <td>{p.transaction_ref}</td>
                          <td>{p.notes}</td>
                          <td style={{ textAlign: "center" }}>
                            {p.payment_file ? (
                              <a
                                href={`${HOST_PREFIX}images/payments/${p.id}/${p.payment_file}`}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {p.payment_file}
                              </a>
                            ) : (
                              "-"
                            )}
                          </td>
                          <td>
                            <i className="fa fa-edit mr-2" data-toggle="modal" data-target="#paymentEditModal" onClick={() => this.updatePaymentState(p)}></i>
                            <i className="fa fa-trash" style={{ cursor: "pointer" }} onClick={() => { if (window.confirm("Are you sure you want to delete this payment?")) { this.props.deletePayment(p.id); } }}></i>
                          </td>
                        </tr>
                      ));
                    })
                  ) : (
                    <tr><td colSpan="13">No Invoices Found</td></tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default VendorPaymentComponent;
